import { faTicket } from '@fortawesome/pro-regular-svg-icons';

import { FAIcon } from './fa-icon';

export const TicketIcon = ({ width }: { width?: string }) => (
  <FAIcon icon={faTicket} width={width} />
);
